// Resolve runtime asset paths (GLBs, textures, thumbnails) against wherever the
// app is actually served from — domain root, a /vanity/ subfolder, a subdomain,
// anything — with no build-time base and no rebuild when it moves.
//
// The bundled JS lives at  <appRoot>/assets/index-<hash>.js , and the browser
// sets import.meta.url to that file's absolute URL at runtime. We strip the
// "assets/..." tail to recover <appRoot>/ and prefix every asset with it.
// (Deliberate string math on import.meta.url, not `new URL("literal", import.meta.url)`,
//  which Vite would otherwise try to resolve at build time.)

function computeBase() {
  try {
    const u = import.meta.url; // e.g. https://site.com/vanity/assets/index-abc.js
    const marker = u.lastIndexOf("/assets/");
    if (marker !== -1) return u.slice(0, marker + 1); // https://site.com/vanity/
    return u.slice(0, u.lastIndexOf("/") + 1);
  } catch {
    return "/";
  }
}

const BASE = computeBase();

export function asset(path) {
  if (path == null) return path;
  return BASE + String(path).replace(/^\//, "");
}
